// assets/custom-language-switcher.js
(() => {
  'use strict';

  const DEFAULT_FROM = 'it';
  const SELECT_SELECTOR = '[data-custom-language-select]';
  const COOKIE_DOMAIN =
    (window.GTRANSLATE_COOKIE_DOMAIN || '').trim() ||
    location.hostname.replace(/^www\./, '');

  // window.name keys
  const NAME_LANG_KEY = '__gt_lang=';
  const NAME_FIRST_RELOAD_KEY = '__gt_first_lang_reload_done=1';

  function getNameLang() {
    const n = window.name || '';
    const i = n.indexOf(NAME_LANG_KEY);
    if (i === -1) return null;
    return n.slice(i + NAME_LANG_KEY.length, i + NAME_LANG_KEY.length + 2);
  }
  function setNameLang(lang) {
    const n = window.name || '';
    const cleaned = n.replace(new RegExp(NAME_LANG_KEY + '[a-z]{2}', 'g'), '');
    window.name = cleaned + NAME_LANG_KEY + lang;
  }
  function hasFirstReloadGuard() {
    return (window.name || '').includes(NAME_FIRST_RELOAD_KEY);
  }
  function setFirstReloadGuard() {
    if (!hasFirstReloadGuard()) window.name = (window.name || '') + NAME_FIRST_RELOAD_KEY;
  }

  function emitLang(lang) {
    const l = (lang || DEFAULT_FROM).toLowerCase();
    window.__clswitch_currentLang = l;
    document.dispatchEvent(new CustomEvent('clswitch:lang', { detail: { lang: l } }));
  }

  // cookies
  function getCookie(name) {
    const m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)')
    );
    return m ? m[1] : null;
  }
  function setCookieRaw(name, value, { domain = null, path = '/', days = 30 } = {}) {
    let cookie = `${name}=${value};path=${path};SameSite=Lax`;
    if (typeof days === 'number') {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      cookie += `;expires=${d.toUTCString()}`;
    }
    if (domain) cookie += `;domain=${domain}`;
    document.cookie = cookie;
  }
  function expireCookie(name, { domain = null, path = '/' } = {}) {
    document.cookie =
      `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};SameSite=Lax` +
      (domain ? `;domain=${domain}` : '');
  }
  function parseGoogTransCookie() {
    const raw = getCookie('googtrans');
    if (!raw) return null;
    let v = raw;
    try { v = decodeURIComponent(raw); } catch (e) {}
    if (v === 'none') return DEFAULT_FROM;
    const m = v.match(/^\/([a-z]{2})\/([a-z]{2})$/i);
    if (m) return (m[2] || DEFAULT_FROM).toLowerCase();
    return null;
  }

  // doGTranslate (best effort)
  function callDoGTranslate(toLang) {
    try {
      if (typeof window.doGTranslate !== 'function') return false;
      window.doGTranslate(`${DEFAULT_FROM}|${toLang}`);
      return true;
    } catch (e) {
      return false;
    }
  }

  function persistLang(toLang) {
    const lang = (toLang || DEFAULT_FROM).toLowerCase();
    setNameLang(lang);

    if (lang === DEFAULT_FROM) {
      const v = `/${DEFAULT_FROM}/${DEFAULT_FROM}`;
      setCookieRaw('googtrans', v, { domain: null });
      setCookieRaw('googtrans', v, { domain: COOKIE_DOMAIN });
      callDoGTranslate(DEFAULT_FROM);
      expireCookie('googtrans', { domain: null });
      expireCookie('googtrans', { domain: COOKIE_DOMAIN });
      return;
    }

    const v = `/${DEFAULT_FROM}/${lang}`;
    setCookieRaw('googtrans', v, { domain: null });
    setCookieRaw('googtrans', v, { domain: COOKIE_DOMAIN });
  }

  function setSelectEverywhere(lang) {
    document.querySelectorAll(SELECT_SELECTOR).forEach((sel) => {
      sel.value = lang;
    });
  }

  // APPLY (brutale refresh on first user change)
  function applyLanguage(lang, { userInitiated = false } = {}) {
    const toLang = (lang || DEFAULT_FROM).toLowerCase();

    setSelectEverywhere(toLang);
    emitLang(toLang);
    persistLang(toLang);

    // best effort
    callDoGTranslate(toLang);

    // refresh UNA volta sola sul primo cambio lingua utente
    if (userInitiated && !hasFirstReloadGuard()) {
      setFirstReloadGuard();
      setTimeout(() => location.reload(), 80);
    }
  }

  function bindOnce() {
    if (window.__clswitch_core_bound) return;
    window.__clswitch_core_bound = true;

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLSelectElement)) return;
      if (!t.matches(SELECT_SELECTOR)) return;
      applyLanguage((t.value || DEFAULT_FROM).toLowerCase(), { userInitiated: true });
    });
  }

  function init() {
    bindOnce();

    // 🔥 NO-FLICKER BOOT:
    // Se cookie esiste, è l’unica source-of-truth all’avvio.
    const cookieLang = parseGoogTransCookie();
    const nameLang = getNameLang();

    const initial = (cookieLang || nameLang || DEFAULT_FROM).toLowerCase();

    setSelectEverywhere(initial);
    emitLang(initial);

    // poll breve solo per aggiornare se cookie cambia dopo
    let tries = 0;
    const poll = setInterval(() => {
      tries++;
      const c = parseGoogTransCookie();
      if (c && c !== window.__clswitch_currentLang) {
        setSelectEverywhere(c);
        emitLang(c);
      }
      if (tries > 30) clearInterval(poll); // ridotto: meno possibilità di “saltare”
    }, 120);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();